import React from 'react';
import LineItemProductWizard from './LineItemProductWizard';

/**
 * Order line items: delegates to {@link LineItemProductWizard}.
 * Backup of the previous standalone implementation: `OrderProductWizard.legacy.js`.
 */
const OrderProductWizard = props => (
  <LineItemProductWizard
    lineItemContext="order"
    parentId={props.orderId}
    parentCurrency={props.orderCurrency}
    show={props.show}
    onHide={props.onHide}
    onSaveSuccess={props.onSaveSuccess}
    lineItemWizardConfig={props.lineItemWizardConfig}
  />
);

export default OrderProductWizard;
